<template>
  <div class="wrapper">
    <side-bar> 
      <mobile-menu slot="content"></mobile-menu>
      <sidebar-link to="/admin/home" @click='reload()'  style="margin-top:-35px; text-align: left">
        <!--<i class="nc-icon nc-chart-pie-35"></i>-->
        <p>Statistiques</p>
      </sidebar-link>
      <sidebar-link to="/admin/suivi_clients" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-layers-3"></i>-->
        <p>Liste des clients</p>
      </sidebar-link>


       <sidebar-link to="/admin/suivi_actions" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-bullet-list-67"></i>-->
        <p>Suivi des actions</p>
         </sidebar-link>

      <sidebar-link to="/admin/action?new" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-paper-2"></i>-->
        <p>Gestion des actions</p>
      </sidebar-link>
      <!-- ------------------------------------------------------------------ -->
        <!-- <sidebar-link to="/admin/Filtrer" @click='reload()'>
        <i class="nc-icon nc-bullet-list-67"></i>
        <p>Filtrer Action</p>
      </sidebar-link> -->
      <!-- ******************************************************** -->
   
      <sidebar-link to="/admin/Liste_taches" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-badge"></i>-->
        <p>Suivi des tâches</p>
      </sidebar-link>
      <sidebar-link to="/admin/Planning" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-single-copy-04"></i>-->
        <p>Planning</p>
      </sidebar-link>
      <sidebar-link to="/admin/maps" @click='reload()' style="text-align: left">
        <!--<i class="nc-icon nc-pin-3"></i>-->
        <p>MAPS</p>
      </sidebar-link>
      <!--
      <sidebar-link to="/admin/user" @click='reload()' style="text-align: left">-->
        <!--<i class="nc-icon nc-circle-09"></i>-->
         <!--<p>Utilisateurs</p>
      </sidebar-link>-->

      <sidebar-link to="/admin/logout" @click='reload()' style="text-align: left">
          <!--<i class="nc-icon nc-button-power"></i>-->
          <p>Déconnexion</p>
      </sidebar-link>

 
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click="toggleSidebar">
      </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss">
p{
  text-transform : none !important;
  font-size: 13px !important;
  font-family: verdana;
}
</style>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    mounted() {
     // console.log('test')
      this.toggleSidebar()
    },
    methods: {
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      reload(){
        window.location.href = "http://localhost:8081/#/admin/Planning";
        console.log('reload')
      },

      logout() {
          console.warn("logout");
          localStorage.clear();
          this.$session.destroy();
          this.$router.push('/login');
        }
    }
  }

</script>
